import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=f72d63b0&scoped=true&"
import script from "./Integration.vue?vue&type=script&lang=js&"
export * from "./Integration.vue?vue&type=script&lang=js&"
import style0 from "./Integration.vue?vue&type=style&index=0&id=f72d63b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72d63b0",
  null
  
)

export default component.exports